var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSend48Line = function SvgIconSend48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.85 10.15a2.9 2.9 0 0 0-2.92-.72l-21.92 6.89c-2.25.71-3.71 2.7-3.71 5.06 0 2.36 1.46 4.35 3.71 5.05l6.5 2.04 2.04 6.5c.71 2.25 2.69 3.71 5.06 3.71 2.36 0 4.35-1.46 5.06-3.71l6.89-21.92c.33-1.04.05-2.15-.72-2.92l.01.02Zm-9.42 23.82c-.39 1.23-1.48 1.33-1.81 1.33-.33 0-1.42-.1-1.81-1.33l-2-6.37 5.99-5.99-2.4-2.4-5.99 5.99-6.37-2c-1.23-.39-1.33-1.48-1.33-1.81 0-.33.1-1.42 1.33-1.81l21-6.61-6.61 21Z",
    fill: "current"
  })));
};
export default SvgIconSend48Line;